import { SvgIcon } from "@material-ui/core";

export const EditIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M17.5833 9.14583L14.0417 5.64583L15.2083 4.47917C15.5278 4.15972 15.9201 4 16.3854 4C16.8507 4 17.2431 4.15972 17.5625 4.47917L18.7292 5.64583C19.0486 5.96528 19.2153 6.35069 19.2292 6.80208C19.2431 7.25347 19.0903 7.63889 18.7708 7.95833L17.5833 9.14583ZM4.83333 19.2083C4.59722 19.2083 4.39931 19.1285 4.23958 18.9688C4.07986 18.809 4 18.6111 4 18.375V16.0208C4 15.9097 4.02083 15.8021 4.0625 15.6979C4.10417 15.5938 4.16667 15.5 4.25 15.4167L12.8333 6.83333L16.375 10.375L7.79167 18.9583C7.70833 19.0417 7.61458 19.1042 7.51042 19.1458C7.40625 19.1875 7.29861 19.2083 7.1875 19.2083H4.83333Z" />
    </SvgIcon>
  );
};
